module.exports = __webpack_public_path__ + "static/media/20ECE30.a4f61269.jpg";